import mixpanel from 'mixpanel-browser';

export default function trackEvent(eventName, props) {
  mixpanel.track(eventName, props);
}